import styled from 'styled-components';
import { PrePreOrderCheckoutTransitionOverlayStyled } from '../PrePreOrderCheckoutTransitionOverlayStyled';

export const PrePreOrderCheckoutTransitionOverlayStyledAC = styled(PrePreOrderCheckoutTransitionOverlayStyled)``;
